<template>
  <v-container>
    <div class="customers">
      <ContentHeader
        header-icon="$customerClipboard"
        header-title="My Customers"
      />
      <pt-sheet
        title="Customer Overview"
        subtitle="Select a customer below to view details or complete tasks."
      >
        <v-data-table
          class="main-table"
          :headers="headers"
          :items="items"
          hide-default-footer
          disable-sort
          :options="tableOptions"
        >
          <!-- Note, we need items slot for row level class until https://github.com/vuetifyjs/vuetify/issues/8643 is implemented -->
          <template v-slot:item="{ item, index }">
            <tr v-if="isFirstCompliantIndex(index)">
              <td style="padding:0" colspan="5">
                <v-divider class="mt-8 mb-8"></v-divider>
              </td>
            </tr>
            <tr :class="getRowClass(item.complianceStatus)" :key="item.employeeId">
              <td class="status-column">
                <span
                  :class="['dot mr-1', getStatusColor(item.complianceStatus)]"
                ></span>
                {{ getComplianceStatusDisplay(item.complianceStatus) }}
              </td>
              <td class="customer-name-column">{{ item.customerName }}</td>
              <td class="customer-since-column">{{ item.customerSince }}</td>
              <td class="text-right">
                <v-btn
                  v-if="item.enrollmentComplete"
                  height="32px"
                  min-width="32px"
                  :to="'customers/' + item.clientId + '/detail'"
                  @click.native="
                    logEvent('Clicked on Customer', {
                      Client: item.customerName
                    })
                  "
                  class="tertiary"
                  depressed
                >
                  <v-icon color="primary">mdi-arrow-right</v-icon>
                </v-btn>
                <yellow-button
                  v-else
                  class="back-to-enrollment-button"
                  @click="enterSignup(item.signupCode)"
                  >Complete Enrollment</yellow-button
                >
              </td>
            </tr>
          </template>
        </v-data-table>
      </pt-sheet>
    </div>
  </v-container>
</template>

<script>
import { customersAPI } from "@/services/api";
import { get } from "@/services/request";
import YellowButton from "@/components/providertrust/buttons/SmallYellowButton";
import ContentHeader from "@/views/ContentHeader.vue";
import PtSheet from "@/components/PtSheet.vue";

const tableOptions = {
  itemsPerPage: -1
};

export default {
  data: () => ({
    headers: [
      {
        text: " Compliance Status",
        value: "complianceStatus"
      },
      { text: "Customer", value: "customer" },
      { text: "Customer Since", value: "customerSince" },
      { text: " ", value: "action", align: "end" }
    ],
    items: [],
    tableOptions
  }),
  components: {
    PtSheet,
    ContentHeader,
    YellowButton
  },
  created() {
    this.logEvent("Landed on my customers page");
    this.loadData();
  },
  methods: {
    loadData() {
      get(customersAPI).then(response => {
        if (response && response.data) {
          this.items = response.data || [];
        }
      });
    },
    getRowClass(status) {
      return status !== "Compliant" && "alert";
    },
    getStatusColor(status) {
      if (status === "Compliant") return "success";
      else return "error";
    },
    getComplianceStatusDisplay(status) {
      if (status === "Compliant") {
        return "Compliant";
      } else {
        return "Not Compliant";
      }
    },
    isFirstCompliantIndex: function(index) {
      return (
        index > 0 &&
        this.items[index].complianceStatus === "Compliant" &&
        this.items[index - 1].complianceStatus !== "Compliant"
      );
    },
    enterSignup(signupCode) {
      this.logEvent("Clicked button to re-enter signup");

      this.$router.push({
        name: "vendorSignup",
        params: { signupCode }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
/** TABLES **/
.main-table.hide-headers
  ::v-deep .v-data-table-header
    visibility: hidden
    max-height: 0
    height: 0
    display: block


/** DETAILS BUTTON **/
.load-btn
  background-color: $btn-bgcolor !important
  color: $primary
  font-weight: 700
  text-transform: capitalize

.v-btn
  font-weight: bold
  letter-spacing: unset
  text-indent: unset
  font-size: 1rem

.load-btn.action-btn
  min-width: 0
</style>
